import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App, { FatalError } from './App'
import { UpdatePrompt } from './shell/UpdatePrompt'
import { applyTheme, readThemeMirror } from './shell/theme'
import './styles.css'

// Before the first paint, from the localStorage mirror: no flash of the wrong theme while
// IndexedDB opens.
applyTheme(readThemeMirror())

const container = document.getElementById('root')
if (!container) throw new Error('#root missing from index.html')

const root = createRoot(container)

try {
  root.render(
    <StrictMode>
      <App>
        <UpdatePrompt />
      </App>
    </StrictMode>,
  )
} catch (err) {
  root.render(<FatalError error={err instanceof Error ? err : new Error(String(err))} />)
}
